import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../../shared/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { MapConstants } from '../../map_constants';
import { Store } from '@ngrx/store';
import { initialMapState, MapState } from '../../state/map-state';
import { REDCRSS_EVENTS } from '../../../../shared/services/constants/redcross_evemts';
import { MAX_PAST_ORDERS, MIN_PAST_ORDERS } from './constants';
import { mapToggle, mapUpdate } from '../../state/map-actions-creator';
import { IAppState } from '../../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'yi-map-setup',
  template: require('./map_setup.component.html'),
  styles: [require('./map_setup.component.scss')]
})

export class MapSetupComponent implements OnInit {

  public isNewEditorEnabled = false;
  public isNewDeliveryEnabled = false;
  private turnedOnMsg;
  private turnedOffMsg;
  private mapSettings = initialMapState;
  private missingProductText;
  private isWidgetV3: boolean;
  SWITCH_COLOR;
  constructor(
    private toasterService: ToastService,
    private translateService: TranslateService,
    private redCrossService: AnalyticsTrackingProvider,
    private store: Store<IAppState>
  ) {
    this.missingProductText = this.translateService.instant('MAP.PRODUCT');

    this.translateService.stream(['MAP.TURNED_ON', 'MAP.TURNED_OFF']).subscribe(
      (translated) => {
        this.turnedOnMsg = translated['MAP.TURNED_ON'];
        this.turnedOffMsg = translated['MAP.TURNED_OFF'];
      });

    this.store.select(state => state.app.install.map).subscribe((data: MapState) => {
      this.mapSettings = data;
      this.updateMapSettings();
    });

    this.store.select(state => state.app.install.integrate).pipe(take(1)).subscribe(
      items => {
        this.isWidgetV3 = items.hasWidgetV3;
      });

    this.SWITCH_COLOR = MapConstants.SWITCH_COLOR;
  }

  ngOnInit() {
    this.redCrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, { pageCategory: 'Installation V2' });
    this.redCrossService.page(REDCRSS_EVENTS.ONBOARDING, {
      category: 'Reviews',
      phaseName: 'Onboarding Step 1',
      phase: 1,
      status: 'started',
    });
    this.redCrossService.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: REDCRSS_EVENTS.COLLECT_REVIEWS,
      stepNum: 1,
      isWidgetV3: this.isWidgetV3,
      status: REDCRSS_EVENTS.STARTED
    });
    this.updateMapSettings();
    this.isNewEditorEnabled = this.mapSettings.hasPostmanEditorFeature;
    this.isNewDeliveryEnabled = this.mapSettings.hasPostmanDeliveryFeature;
  }

  onUpdateSignature(storeName: string) {
    this.store.dispatch(mapUpdate({ payload: { signatureChanged: true, storeName } }));
    this.updateMapSettings();
  }

  onUpdateSubject(subject: string) {
    this.store.dispatch(mapUpdate({ payload: { subjectChanged: true, subject } }));
    this.updateMapSettings();
  }

  onUpdateBody(message: string) {
    this.store.dispatch(mapUpdate({ payload: { bodyChanged: true, message } }));
    this.updateMapSettings();
  }

  updateMapSettings() {
    this.updateMissingProduct();
  }

  onSwitchToggle(e) {
    if (e) {
      this.store.dispatch(mapToggle({enabled: true}));
      this.redCrossService.track('Feature Enabled', { feature: 'MAP' });
      this.toasterService.success(this.turnedOnMsg);
    } else {
      this.store.dispatch(mapToggle({enabled: false}));
      this.redCrossService.track('Feature Disabled', { feature: 'MAP' });
      this.toasterService.errorNoTitle(this.turnedOffMsg);
    }
  }

  onSwitchDaysToggle(e) {
    if (e) {
      this.store.dispatch(mapUpdate({ payload: { pastOrdersEnabled: true } }));
    } else {
      this.store.dispatch(mapUpdate({ payload: { pastOrders: 0, pastOrdersEnabled: false } }));
    }
  }

  updateMissingProduct() {
    let missingProduct = !this.mapSettings.message.includes(this.missingProductText);
    if (missingProduct !== this.mapSettings.missingProduct) {
      this.store.dispatch(mapUpdate({ payload: { missingProduct: missingProduct } }));
    }
  }

  decreasePastOrders() {
    if (this.mapSettings.pastOrders > MIN_PAST_ORDERS) {
      this.store.dispatch(mapUpdate({ payload: { pastOrders: this.mapSettings.pastOrders - 1 } }));
    } else {
      this.store.dispatch(mapUpdate({ payload: { pastOrders: 0, pastOrdersEnabled: false } }));
    }
  }

  increasePastOrders() {
    if (this.mapSettings.pastOrders < MAX_PAST_ORDERS) {
      this.store.dispatch(mapUpdate({ payload: { pastOrders: this.mapSettings.pastOrders + 1, pastOrdersEnabled: true } }));
    }
  }

  onDaysChange(e) {
    let newValue = parseInt(e.currentTarget.value, 10);
    if (newValue <= MAX_PAST_ORDERS && newValue >= MIN_PAST_ORDERS) {
      this.store.dispatch(mapUpdate({ payload: { pastOrders: newValue } }));
    } else if (newValue > MAX_PAST_ORDERS) {
      e.currentTarget.value = MAX_PAST_ORDERS;
      this.store.dispatch(mapUpdate({ payload: { pastOrders: MAX_PAST_ORDERS } }));
    } else {
      e.currentTarget.value = this.mapSettings.pastOrders;
    }
  }
}
